import { POS_ROUTE } from "../../../constants/constants";

export const COMPANY_ROUTE = POS_ROUTE + "/company"